export class AccountingStatusType {
    readonly name: string;
    readonly id: number;
    readonly milestone: string;

    public isIn = (arr: { jobSalaryTypeId: number }[]): boolean => {
        arr = arr != null ? arr : [];
        return arr.findIndex(t => t.jobSalaryTypeId === this.id) >= 0;
    };

    private constructor(id: number, name: string, milestone: string) {
        this.id = id;
        this.name = name;
        this.milestone = milestone;
    }

    public static VOID = new AccountingStatusType(10, "void", "cancelled");
    public static PENDING = new AccountingStatusType(
        20,
        "pending",
        "pending approval"
    );
    public static CONFIRMED = new AccountingStatusType(
        30,
        "confirmed",
        "pending approval"
    );
    public static APPROVED = new AccountingStatusType(
        40,
        "approved",
        "approved"
    );
    public static CREDITED = new AccountingStatusType(
        50,
        "credited",
        "cancelled"
    );
    public static UNSCHEDULED = new AccountingStatusType(
        60,
        "unscheduled",
        "unscheduled"
    );


    public static asArray = () => [
        AccountingStatusType.VOID,
        AccountingStatusType.PENDING,
        AccountingStatusType.CONFIRMED,
        AccountingStatusType.APPROVED,
        AccountingStatusType.CREDITED,
        AccountingStatusType.UNSCHEDULED,
    ];

    public static fromId = (id: number) => {
        const t = AccountingStatusType.asArray().find(t => t.id === id);
        if (!t) {
            throw new Error(`unknown accounting status type requested: ${id}`);
        }
        return t;
    };

    public isPending = () => this.id === AccountingStatusType.PENDING.id;

    public isVoid = () => this.id === AccountingStatusType.VOID.id;

    public isApproved = () => this.id === AccountingStatusType.APPROVED.id;

    public isConfirmed = () => this.id === AccountingStatusType.CONFIRMED.id;

    public isCredited = () => this.id === AccountingStatusType.CREDITED.id;

    public isUnscheduled = () => this.id === AccountingStatusType.UNSCHEDULED.id;

    public isPendingOrConfirmed = () =>
        this.id === AccountingStatusType.PENDING.id ||
        this.id === AccountingStatusType.CONFIRMED.id;

    public isPendingOrUnscheduled = () =>
        this.id === AccountingStatusType.PENDING.id ||
        this.id === AccountingStatusType.UNSCHEDULED.id;
}
